
import React from 'react'

export default function QuestionHelp({ tempText, RouterFeedback }) {
    return <div style={{height: '0px'}}></div>
    // return <div className="helpContainer">
    //     <div className='helpLeft'>
    //         <div className="helpTipText1">{tempText?.text6}</div>
    //         <div className="helpTipText2">{tempText?.text7}</div>
    //     </div>
    //     <div className="helpTipBtn" onClick={RouterFeedback}>
    //         <div className="helpTipBtnText">{tempText?.text8}</div>
    //     </div>
    // </div>
}